module.exports = __webpack_public_path__ + "static/media/mastercard.40a8ea74.svg";